import deepmerge from 'deepmerge';
import React, { createContext, useContext } from 'react';
const ConfigContext = createContext({});
const getConfig = (config) => {
    if (config?.data) {
        return {
            ...config.data,
            bankregnr: config.bankregnr,
        };
    }
    if (config) {
        return config;
    }
    return {};
};
export default (config) => {
    return ({ state, children }) => {
        const overrides = getConfig(state);
        const mergedConfig = deepmerge(config ?? {}, overrides);
        return React.createElement(ConfigContext.Provider, { value: mergedConfig }, children);
    };
};
export function useConfig() {
    return useContext(ConfigContext);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9jb25maWctcHJvdmlkZXIvc3JjL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFNBQVMsTUFBTSxXQUFXLENBQUM7QUFDbEMsT0FBTyxLQUFLLEVBQUUsRUFBVyxhQUFhLEVBQUUsVUFBVSxFQUFhLE1BQU0sT0FBTyxDQUFDO0FBRTdFLE1BQU0sYUFBYSxHQUFxQixhQUFhLENBQVUsRUFBRSxDQUFDLENBQUM7QUFnQm5FLE1BQU0sU0FBUyxHQUFHLENBQXVCLE1BQVMsRUFBYyxFQUFFO0lBQzlELElBQUksTUFBTSxFQUFFLElBQUksRUFBRSxDQUFDO1FBQ2YsT0FBTztZQUNILEdBQUcsTUFBTSxDQUFDLElBQUk7WUFDZCxTQUFTLEVBQUUsTUFBTSxDQUFDLFNBQVM7U0FDOUIsQ0FBQztJQUNOLENBQUM7SUFDRCxJQUFJLE1BQU0sRUFBRSxDQUFDO1FBQ1QsT0FBTyxNQUFNLENBQUM7SUFDbEIsQ0FBQztJQUNELE9BQU8sRUFBRSxDQUFDO0FBQ2QsQ0FBQyxDQUFDO0FBRUYsZUFBZSxDQUF1QixNQUFTLEVBQXNCLEVBQUU7SUFDbkUsT0FBTyxDQUFDLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxFQUFFLEVBQUU7UUFDM0IsTUFBTSxTQUFTLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ25DLE1BQU0sWUFBWSxHQUFHLFNBQVMsQ0FBYSxNQUFNLElBQUksRUFBRSxFQUFFLFNBQWMsQ0FBQyxDQUFDO1FBQ3pFLE9BQU8sb0JBQUMsYUFBYSxDQUFDLFFBQVEsSUFBQyxLQUFLLEVBQUUsWUFBWSxJQUFHLFFBQVEsQ0FBMEIsQ0FBQztJQUM1RixDQUFDLENBQUM7QUFDTixDQUFDLENBQUM7QUFFRixNQUFNLFVBQVUsU0FBUztJQUNyQixPQUFPLFVBQVUsQ0FBSSxhQUEyQixDQUFDLENBQUM7QUFDdEQsQ0FBQyJ9